import _both from "ramda/es/both";
import _takeLast from "ramda/es/takeLast";
import _compose from "ramda/es/compose";
import _equals from "ramda/es/equals";
import _converge from "ramda/es/converge";
import parseInt10 from './parseInt10';
import isActorAccount from './isActorAccount';
import actorAccountMod from './actorAccountMod';

var modValid = _converge(_equals, [actorAccountMod, _compose(parseInt10, _takeLast(2))]);

export default _both(isActorAccount, modValid);